import React, { Component } from 'react'
import style from './style.css'
import T from '../../../SPRINTA/translate/T'

import { Col, Row } from '../../atoms/Grid'
import Button from '../../atoms/Button'
import { Radio, Textarea, FormGroup, form } from '../../atoms/Forms'
import Loading from '../../atoms/Loading'

import * as discussion from '../../../utils/discussion.js'



class PostCommentForum extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {
                privacity: props.private ? 'private' : 'public',
                comment: ''
            },
            status: 'done'
        }
    }
    handleChange = (event) => {
        this.setState( form(this.state.form, event.target) )
    }
    handleSubmit = (e) => {
        e.preventDefault()
        this.setState({
            status: 'loading'
        })
        var content = this.state.form.comment
        var privacity = this.state.form.privacity
        discussion.newQuestion(this.props.token, this.props.type, content, privacity)
        .then(resp => {
            this.setState({
                status: 'done',
                form: {
                    ...this.state.form,
                    comment: ''
                }
            })
            var date = new Date()
            var question = {
                id: resp.id,
                content,
                privacity,
                create_at: `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`,
            }
            this.props.handleAdd(question)
        })
    }
    render() {
        return (
            <form onSubmit={(e) => this.handleSubmit(e)}>
                <Row className={`${style.postcomment}`}>
                    
                    <Col size={12}>
                        <FormGroup>
                            <Textarea
                                value={this.state.form.comment}
                                name='comment'
                                placeholder={T.txt('placeholder_create_question')}
                                disabled={this.props.disabled || this.state.status === 'loading' || ''}
                                handleChange={this.handleChange} />
                        </FormGroup>
                        
                        <Row>
                            <Col size={7} float='right'>
                                <div style={{float: 'right'}}>
                                    <Button inline color="orange" disabled={this.state.form.comment.length === 0  && this.state.status === 'done'}>
                                        {(this.state.status === 'loading') ? (
                                            <Loading
                                                color='#fff'
                                                size='30px' />
                                        ) : T.txt('publish')}
                                    </Button>
                                </div>
                                {!this.props.private && (
                                    <div className={style.option}>                                            
                                        <Radio
                                            handleChange={this.handleChange}
                                            checked={this.state.form.privacity === 'private'}
                                            label={T.txt('label_private')}
                                            value='private'
                                            name='privacity' />
                                    </div>
                                )}
                                {!this.props.private && (
                                    <div className={style.option}>
                                        <Radio
                                            handleChange={this.handleChange}
                                            checked={this.state.form.privacity === 'public'}
                                            value='public'
                                            label={T.txt('label_public')}
                                            name='privacity' />
                                    </div>
                                )}
                                
                                
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </form>
        )
    }
}

export default PostCommentForum;


// WEBPACK FOOTER //
// ./src/components/molecules/PostQuestionForum/index.js